import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendPlaneLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.2509 3.53155C21.0389 3.32889 21.7262 4.10218 21.4325 4.86103L15.4325 20.361C15.175 21.0261 14.324 21.2156 13.8087 20.7227L10.4265 17.4876L9.2241 18.69C8.58784 19.3263 7.49992 18.8757 7.49992 17.9759V14.6882L2.30868 9.72268C1.74196 9.1806 1.99133 8.22685 2.75086 8.03155L20.2509 3.53155ZM18.1359 7.83693L10.1379 14.4439L14.1083 18.2416L18.1359 7.83693ZM16.5581 6.54619L4.99085 9.52061L8.68269 13.0519L16.5581 6.54619Z" })
});
export default SvgSendPlaneLine;
